import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityVerifyView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

onMounted(async () => {
  const mailAuthKey = (route?.params?.mailAuthKey ?? '') as string;
  localStorage.removeItem('mailSecurityUpdateInfo');
  // Redirect to verify-by-password screen
  router.replace({ name: 'verify-by-password', params: { mailAuthKey } });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span"))
}
}

})